// extracted by mini-css-extract-plugin
export default {"container":"Gridle_container__c6zud","word-vis":"Gridle_word-vis__HS04e","grid":"Gridle_grid__WROTq"};